import { MenuItem, Checkbox, FormControlLabel, Select, FormControl, Typography, Tooltip } from '@mui/material';
import { Controller } from 'react-hook-form';
import Grid from '@mui/system/Grid';

import fontWeight from '../../styles/mui/fontWeight';
import colors from '../../styles/colors/colors';
import { TooltipStyle } from '../../styles/common/style';

const CheckboxDropdown = ({ control, name, label, options, rules, defaultValue = [] }: any) => {
  return (
    <FormControl fullWidth>
      <Typography
        variant="body1"
        fontWeight={fontWeight[2]}
        color={colors.fonts[2]}
      >
        {label}
      </Typography>

      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field }) => {
          const selectedIds = Array.isArray(field.value)
            ? field.value.map((item: any) => item.careTypeId)
            : [];

          // Get selected labels for tooltip and renderValue
          const selectedLabels = options
            .filter((option: any) =>
              selectedIds.includes(option.value)
            )
            .map((option: any) => option.label);

          return (
            <Select
              multiple
              value={field.value}
              onChange={(event) => {
              const selected = event.target.value as any[];
              const newValue = selected.map((val) =>
                typeof val === "object" && val.careTypeId !== undefined
                ? val
                : { careTypeId: val }
              );
              field.onChange(newValue);
              }}
              renderValue={() => (
              <>
                <Grid sx={{ display: 'flex', marginTop: 1 }}>
                <Tooltip
                  title={selectedLabels.join(", ")}
                  arrow
                  slotProps={{
                  popper: {
                    sx: TooltipStyle,
                  },
                  }}
                >
                  <Typography variant="caption" fontSize={15} fontWeight={fontWeight[3]} maxWidth={"10rem"}>
                  {selectedLabels.length > 0 ? selectedLabels.join(", ") : "Select an option"}
                  </Typography>
                </Tooltip>
                </Grid>
              </>
              )}
              variant="standard"
              displayEmpty
              MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              PaperProps: {
                style: {
                maxHeight: 240,
                overflowY: "auto",
                },
              },
              }}
              sx={{
              '& .MuiSelect-icon': {
                backgroundColor: colors.white[1],
                borderRadius: '4px',
                padding: '2px',
              },
              }}
            >
              {options.length === 0 && (
              <MenuItem disabled value="">
                <em>No options</em>
              </MenuItem>
              )}
              {options.map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                <FormControlLabel
                control={
                  <Checkbox
                  checked={selectedIds.includes(option.value)}
                  onChange={(e) => {
                    let newValue;
                    if (e.target.checked) {
                    newValue = [
                      ...field.value,
                      { careTypeId: option.value }
                    ];
                    } else {
                    newValue = field.value.filter(
                      (item: any) => item.careTypeId !== option.value
                    );
                    }
                    field.onChange(newValue);
                  }}
                  />
                }
                label={option.label}
                />
              </MenuItem>
              ))}
            </Select>
          );
        }}
      />
    </FormControl>
  );
};

export default CheckboxDropdown;
